export class LoadGlobalSettings {
  public static readonly type = '[GlobalSettings] Load Global Settings';
}
